import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { createPanelsError, PanelsErrorCode } from './errors';
export class PanelsNamespace extends PrivateAPINamespace {
    openLanguageSupportPanel(appDefinitionId) {
        if (!appDefinitionId) {
            throw createPanelsError(PanelsErrorCode.EmptyApplicationDefId);
        }
        this.ps.hostAPI.editor.openLanguageSupportPanel(appDefinitionId);
    }
    openFontsUploadPanel(appDefinitionId) {
        if (!appDefinitionId) {
            throw createPanelsError(PanelsErrorCode.EmptyApplicationDefId);
        }
        this.ps.hostAPI.editor.openFontsUploadPanel(appDefinitionId);
    }
    openDashboardPanel(appDefinitionId, options) {
        if (!appDefinitionId) {
            throw createPanelsError(PanelsErrorCode.EmptyApplicationDefId);
        }
        this.ps.hostAPI.editor.openDashboardPanel(appDefinitionId, options);
    }
}
PanelsNamespace.namespace = 'panels';
//# sourceMappingURL=PanelsNamespace.js.map